import * as React from 'react'
import { PrismicProvider } from '@prismicio/react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
// Utils
import { repositoryConfigs } from './src/utils/prismicPreviews'
import { linkResolver } from './src/utils/linkResolver'

import '@fontsource/urbanist'
import './src/styles/default.css'

export const wrapRootElement = ({ element }) => (
  <PrismicProvider
    linkResolver={linkResolver}
    externalLinkComponent={({ href, className, ...props }) => {
      if (href.includes('charterauctions.co.uk')) {
        return (
          <a data-location='internal' href={href} target='_self' className={className}>
            {props.children}
          </a>
        )
      }
      return (
        <a data-location='external' href={href} className={className} {...props}>
          {props.children}
        </a>
      )
    }}
    internalLinkComponent={({ href, ...props }) => {
      return (
        <a href={href} {...props}>
          {props.children}
        </a>
      )
    }}>
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>{element}</PrismicPreviewProvider>
  </PrismicProvider>
)
